import * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-9 w-full rounded-4 border border-line-strong bg-surface px-3 py-1 text-sm text-ink-900 shadow-xs transition-colors",
        "placeholder:text-ink-400",
        "focus-visible:outline-none focus-visible:border-p-600 focus-visible:ring-2 focus-visible:ring-p-100",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "aria-invalid:border-vroom-red aria-invalid:ring-vroom-red-soft",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
